import annex6Reducers from './reducers';
export { default as annex6Actions } from './actions';
export { default as annex6Selectors } from './selectors';
export { default as annex6Middlewares } from './middlewares';
export {};
export default annex6Reducers;
